import { useGetEventInfoForServiceCenterQuery } from '@graphql/generated';
import { Flex, LinkV2, TextV2 } from '@withjoy/joykit';
import React from 'react';

type EventWebsiteButtonProps = {
  eventId: string;
};

export const EventWebsiteButton = (props: EventWebsiteButtonProps) => {
  const { data: eventInfo } = useGetEventInfoForServiceCenterQuery({
    variables: {
      eventByIdId: props.eventId,
    },
    fetchPolicy: 'no-cache',
    batchMode: 'off',
  });

  if (!eventInfo) {
    return null;
  }

  return (
    <Flex flexDirection="column">
      <LinkV2 href={`/${eventInfo.eventById?.website}`}>View Event Website</LinkV2>
      <LinkV2 href={`/${eventInfo.eventById?.website}/edit/messaging`}>View Event Messaging Page</LinkV2>
      <LinkV2 href={`/servicecenter/event-safety-rating?eventId=${props.eventId.trim()}`}>Service Center: Event Safety Rating</LinkV2>
      <TextV2>Event ID: {props.eventId}</TextV2>
      <TextV2>Event Website Handle: {eventInfo.eventById?.website}</TextV2>
    </Flex>
  );
};
